import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/styles'
import { Popover, CardActions, Button } from '@material-ui/core'

import { NotificationList, EmptyList } from './components'

const useStyles = makeStyles(() => ({
  root: {
    width: 300,
    maxWidth: '100%'
  },
  actions: {
    justifyContent: 'center',
    padding: 0
  }
}))

const NotificationsPopover = props => {
  const { notifications, anchorEl, ...rest } = props

  const classes = useStyles()

  return (
    <Popover
      {...rest}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
      style={{ marginTop: '1rem' }}>
      <div onClick={props.onClose} className={classes.root}>
        {notifications?.length > 0 ? (
          <>
            <NotificationList notifications={notifications} />
            <CardActions className={classes.actions}>
              <Button
                color="primary"
                onClick={props.onClose}
                component={RouterLink}
                size="small"
                to="/notifications">
                See all
              </Button>
            </CardActions>
          </>
        ) : (
          <EmptyList />
        )}
      </div>
    </Popover>
  )
}

NotificationsPopover.propTypes = {
  anchorEl: PropTypes.any,
  className: PropTypes.string,
  notifications: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
}

export default NotificationsPopover
